<template>
	<v-alert
		v-if="showNotification && !dismissed"
		color="warning"
		icon="mdi-restart"
		border="start"
		closable
		class="restart-notification"
		elevation="2"
		@click:close="dismiss"
	>
		{{ message }}
	</v-alert>
</template>

<script setup lang="ts">
import { apiConfig as operatorAPIConfig } from "@lr-notitia/notitia-operator/client";
import { ref, onMounted, onUnmounted } from "vue";

const showNotification = ref(false);
const dismissed = ref(false);
const message = ref("");
let eventSource: EventSource | null = null;

function dismiss() {
	showNotification.value = false;
	dismissed.value = true;

	// set dismissed to false again after a while, so future restart notfications are shown if page isn't reloaded
	const remainingSeconds = parseInt(message.value.match(/(\d+)/)?.[0] || "0");
	setTimeout(() => {
		dismissed.value = false;
	}, (remainingSeconds + 5) * 1000);
}

function initSSE() {
	// Close any existing connection
	if (eventSource) {
		eventSource.close();
	}

	// Create new SSE connection
	let endpoint = operatorAPIConfig.host;
	endpoint += "/sseRestartNotification";

	eventSource = new EventSource(endpoint);

	eventSource.onopen = () => {};

	eventSource.onmessage = (event) => {
		try {
			const data = JSON.parse(event.data);
			if (data.type === "restart" || data.type === "countdown") {
				message.value = data.message || "";
				showNotification.value = true;
			}
		} catch (err) {
			console.error("Error parsing restart notification:", err);
		}
	};

	eventSource.onerror = (err) => {
		console.error("Restart notification SSE error:", err);
		// Attempt to reconnect
		setTimeout(initSSE, 5000);
	};
}

onMounted(() => {
	initSSE();
});

onUnmounted(() => {
	if (eventSource) {
		eventSource.close();
		eventSource = null;
	}
});
</script>

<style scoped>
.restart-notification {
	position: fixed;
	top: 20px;
	right: 20px;
	z-index: 2000;
	min-width: 300px;
}
</style>
